/**
 * Describes the mode of the search results component and all sub-components.
 * Based on these values varying components are displayed.
 */
export enum SearchResultMode {
  /**
   * Is used if a regular customer search is displayed on the customer search page
   */
  CUSTOMER_SEARCH = 'CUSTOMER_SEARCH',
  /**
   * Is used if the search results are displayed in a duplicate check during customer creation
   */
  DUPLICATE_CHECK = 'DUPLICATE_CHECK',
  /**
   * Is used if a customer search is displayed in a modal for connecting customer to a vehicle
   */
  C2V_LINK = 'C2V_LINK',
  /**
   * Is used if existing customers are searched in the NSC Database (GCDM) for a following sync of customers between Retail CRM and the NSC Database
   */
  MERGE_WITH_NSC = 'MERGE_WITH_NSC',
}
